/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../../app/helpers/restClient';

// this api is only called in the ADD NEW CONTACT screen, to add a new recipient
// direct export is required for using react query mutation
export const processAddNewRecipient = (payload) => {
    const { ContactId, jwtToken, data } = payload;
    const wcEnv = {
        rootUri: '/',
    };

    const resourcePage = `addressbook/v2/occasions/${ContactId}/recipient`;

    return restClient.postFacade(wcEnv, resourcePage, jwtToken, data)
        .then((response) => response) // we should not handle catch here, as it will not fall into onError handling in mutation part and directly move out of code from here
};